
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class Dropdown extends Vue {
  @Prop({ default: false }) value!: boolean

  @Prop({ default: true }) icon: boolean

  @Prop({ default: 'icons8-expand-arrow' }) iconClass: string

  @Prop({ default: '' }) dropdownClass: string

  dropdownOpen: boolean = this.value

  toggle(): void {
    this.dropdownOpen = !this.dropdownOpen
  }

  close(): void {
    if (this.dropdownOpen) this.dropdownOpen = false
  }

  // use emit and watcher so this component can be used without v-model as well
  @Watch('dropdownOpen')
  onDropdownOpenChanged(dropdownOpen: boolean): void {
    this.$emit('input', dropdownOpen)
  }

  @Watch('value')
  onValueChanged(value: boolean): void {
    this.dropdownOpen = value
  }
}
